import type { Animation } from '@ionic/core';
import { EASING_EMPHASIZED_DECCELERATE, fadeIn } from '../../../utils/animations';

export function dropdownOpenAnimation(element: HTMLElement): Animation {
  return fadeIn().duration(250).addElement(element).easing(EASING_EMPHASIZED_DECCELERATE);
}
